import { render } from "./MemberPage.vue?vue&type=template&id=36ce9af3&scoped=true"
import script from "./MemberPage.vue?vue&type=script&lang=js"
export * from "./MemberPage.vue?vue&type=script&lang=js"

import "./MemberPage.vue?vue&type=style&index=0&id=36ce9af3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ce9af3"]])

export default __exports__